import * as XLSX from 'xlsx';

/**
 * 导出Excel（单Sheet）
 * @param {Array} data - 数据数组
 * @param {string} fileName - 文件名
 * @param {string} sheetName - Sheet名称
 */
export const exportExcel = (data, fileName = '数据导出', sheetName = 'Sheet1') => {
  if (!data || data.length === 0) {
    console.warn('没有数据可导出');
    return false;
  }
  
  try {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);
    
    // 设置列宽
    const colWidths = Object.keys(data[0]).map(() => ({ wch: 20 }));
    ws['!cols'] = colWidths;
    
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, `${fileName}.xlsx`);
    
    return true;
  } catch (error) {
    console.error('导出失败:', error);
    throw error;
  }
};

/**
 * 导出Excel（多Sheet）
 * @param {Object} sheets - { sheetName: dataArray, ... }
 * @param {string} fileName - 文件名
 */
export const exportExcelMultiSheet = (sheets, fileName = '数据导出') => {
  if (!sheets || Object.keys(sheets).length === 0) {
    console.warn('没有数据可导出');
    return false;
  }
  
  try {
    const wb = XLSX.utils.book_new();
    
    Object.keys(sheets).forEach((sheetName, index) => {
      const data = sheets[sheetName];
      if (!data || data.length === 0) return;
      
      const ws = XLSX.utils.json_to_sheet(data);
      
      // 设置列宽
      const colWidths = Object.keys(data[0]).map(() => ({ wch: 20 }));
      ws['!cols'] = colWidths;
      
      // Sheet名称限制31个字符
      let name = sheetName || `Sheet${index + 1}`;
      if (name.length > 31) {
        name = name.substring(0, 31);
      }
      
      XLSX.utils.book_append_sheet(wb, ws, name);
    });
    
    XLSX.writeFile(wb, `${fileName}.xlsx`);
    return true;
  } catch (error) {
    console.error('导出失败:', error);
    throw error;
  }
};

/**
 * 导出CSV
 * @param {Array} data - 数据数组
 * @param {string} fileName - 文件名
 */
export const exportCSV = (data, fileName = '数据导出') => {
  if (!data || data.length === 0) {
    console.warn('没有数据可导出');
    return false;
  }
  
  try {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `${fileName}.csv`, { bookType: 'csv' });
    return true;
  } catch (error) {
    console.error('导出失败:', error);
    throw error;
  }
};